import IpubUploadLabel from './src/main'

/* istanbul ignore next */
IpubUploadLabel.install = function(Vue) {
  Vue.component(IpubUploadLabel.name, IpubUploadLabel)
}

export default IpubUploadLabel
